/*
 * Module for the Insurance covered dependents tab
*/
rs.module("content/participant/benefit/insurance/edit/covereddependents",

    [
        "controls/components/event-banner",
        "common/select-helper"
    ],

    function (eventBanner, selectHelper) {

        var _executeSelectionChanged;

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrl, columnIds, grid) {

            // Unpack js selectors
            var form = $.js(jsSelectors.form);

            var updateToken = form.js(jsSelectors.updateToken);
            var coveredDependentKey = form.js(jsSelectors.coveredDependentKey);
            var dependentSelect = form.js(jsSelectors.dependentSelect);
            var effectiveDateInput = form.js(jsSelectors.effectiveDateInput);
            var terminationDateInput = form.js(jsSelectors.terminationDateInput);
            var addCoveredDependentButton = form.js(jsSelectors.addCoveredDependentButton);
            var cancelCoveredDependentButton = form.js(jsSelectors.cancelCoveredDependentButton);

            // Get select helper(s)
            var dependentSelectHelper = selectHelper.getHelper(dependentSelect);

            // On add button click, clear the form
            addCoveredDependentButton.click(function () {

                eventBanner.removeAllMessages();
                grid.selectedValues = null;

                // Reset inputs
                [
                    updateToken,
                    effectiveDateInput,
                    terminationDateInput
                ].forEach((input) => input.clearErrors().val(''));
                coveredDependentKey.val(-1);

                dependentSelectHelper.selectIndex(0);
            });

            // On cancel button click, select first entry and clear event banner.
            cancelCoveredDependentButton.click(function () {

                // Reset inputs
                [
                    effectiveDateInput,
                    terminationDateInput
                ].forEach((input) => input.clearErrors().val(''));
                dependentSelectHelper.selectIndex(0);
                dependentSelect.clearErrors();

                grid.selectedValues = null;
                grid.selectFirstRow();
                eventBanner.removeAllMessages();
            });

            // Listen for row selection 
            grid.selectionChanged(function (values, rows) {

                // This handler fires when the grid is first rendered, but we don't want it to in our case
                // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                if (_executeSelectionChanged && values.length > 0) {

                    $.getJSON(backendUrl, { coveredDependentKey: rows[0][columnIds.coveredDependentKey] }).done(function (data) {

                        // Hidden Token
                        updateToken.val(data.updateToken);
                        coveredDependentKey.val(data.coveredDependentKey);
                        effectiveDateInput.val(data.effectiveDate);
                        terminationDateInput.val(data.terminationDate);
                        dependentSelectHelper.setValue(data.personKey);


                        [
                            effectiveDateInput,
                            dependentSelect
                        ].forEach((input) => input.clearErrors());
                        eventBanner.removeAllMessages();   
                    });
                }

                _executeSelectionChanged = true;
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);